var map = {
	"./Ansar.svg": "./src/core/packages/bank-service/banks/Ansar.svg",
	"./Arman.svg": "./src/core/packages/bank-service/banks/Arman.svg",
	"./Ayandeh.svg": "./src/core/packages/bank-service/banks/Ayandeh.svg",
	"./Bank-Hekmat.svg": "./src/core/packages/bank-service/banks/Bank-Hekmat.svg",
	"./Bank-Markazi.svg": "./src/core/packages/bank-service/banks/Bank-Markazi.svg",
	"./Day.svg": "./src/core/packages/bank-service/banks/Day.svg",
	"./Eghtesad.svg": "./src/core/packages/bank-service/banks/Eghtesad.svg",
	"./Gardeshgari.svg": "./src/core/packages/bank-service/banks/Gardeshgari.svg",
	"./Ghavamin.svg": "./src/core/packages/bank-service/banks/Ghavamin.svg",
	"./Iranzamin.svg": "./src/core/packages/bank-service/banks/Iranzamin.svg",
	"./Karafarin.svg": "./src/core/packages/bank-service/banks/Karafarin.svg",
	"./Khavarmiane.svg": "./src/core/packages/bank-service/banks/Khavarmiane.svg",
	"./Kosar.svg": "./src/core/packages/bank-service/banks/Kosar.svg",
	"./Maskan.svg": "./src/core/packages/bank-service/banks/Maskan.svg",
	"./Mehr-Eghtesad.svg": "./src/core/packages/bank-service/banks/Mehr-Eghtesad.svg",
	"./Mehr.svg": "./src/core/packages/bank-service/banks/Mehr.svg",
	"./Mellat.svg": "./src/core/packages/bank-service/banks/Mellat.svg",
	"./Melli.svg": "./src/core/packages/bank-service/banks/Melli.svg",
	"./Parsian.svg": "./src/core/packages/bank-service/banks/Parsian.svg",
	"./Pasargad.svg": "./src/core/packages/bank-service/banks/Pasargad.svg",
	"./Refah.svg": "./src/core/packages/bank-service/banks/Refah.svg",
	"./Resalat.svg": "./src/core/packages/bank-service/banks/Resalat.svg",
	"./Saderat.svg": "./src/core/packages/bank-service/banks/Saderat.svg",
	"./Salehin.svg": "./src/core/packages/bank-service/banks/Salehin.svg",
	"./Saman.svg": "./src/core/packages/bank-service/banks/Saman.svg",
	"./Samen.svg": "./src/core/packages/bank-service/banks/Samen.svg",
	"./Sanatvamadan.svg": "./src/core/packages/bank-service/banks/Sanatvamadan.svg",
	"./Sarmayeh.svg": "./src/core/packages/bank-service/banks/Sarmayeh.svg",
	"./Sepah.svg": "./src/core/packages/bank-service/banks/Sepah.svg",
	"./Shahr.svg": "./src/core/packages/bank-service/banks/Shahr.svg",
	"./Shaparak.svg": "./src/core/packages/bank-service/banks/Shaparak.svg",
	"./Shetab.svg": "./src/core/packages/bank-service/banks/Shetab.svg",
	"./Sina.svg": "./src/core/packages/bank-service/banks/Sina.svg",
	"./Tejarat.svg": "./src/core/packages/bank-service/banks/Tejarat.svg",
	"./Tosee-Saderat.svg": "./src/core/packages/bank-service/banks/Tosee-Saderat.svg",
	"./Tosee-Taavon.svg": "./src/core/packages/bank-service/banks/Tosee-Taavon.svg",
	"./Tosee.svg": "./src/core/packages/bank-service/banks/Tosee.svg",
	"./keshavarzi.svg": "./src/core/packages/bank-service/banks/keshavarzi.svg",
	"./postbank.svg": "./src/core/packages/bank-service/banks/postbank.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/core/packages/bank-service/banks sync recursive ^\\.\\/.*\\.svg$";